import { render, staticRenderFns } from "./resourceDatabaseManagement.vue?vue&type=template&id=d4caa90a"
import script from "./resourceDatabaseManagement.vue?vue&type=script&lang=js"
export * from "./resourceDatabaseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4caa90a')) {
      api.createRecord('d4caa90a', component.options)
    } else {
      api.reload('d4caa90a', component.options)
    }
    module.hot.accept("./resourceDatabaseManagement.vue?vue&type=template&id=d4caa90a", function () {
      api.rerender('d4caa90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/resourceManagement/resourceDatabaseManagement.vue"
export default component.exports